import { ComparabilitySearchFinalRange } from '../comparability-search-final-range';

export class DiscussFinalRangeResultsModalPayload {
  compSearchId: number;
  jurisdiction: string;
  jurisdictionId: number;
  pliTypeId: number;
  pliAvgTypeId: number;
  containerId: number;
  rangeDiscussion: string;
  finalRangeDetails: ComparabilitySearchFinalRange;
}
